angular.module('shared').factory('FileDownloadService', function() {
  return {
    downloadWithPost: function(url, params) {
      var authToken, form;
      authToken = angular.element('meta[name=csrf-token]').attr('content');
      form = angular.element('<form></form>').attr('action', url).attr('method', 'post');
      form.append(angular.element("<input></input>").attr('type', 'hidden').attr('name', 'authenticity_token').attr('value', authToken));
      if (params) {
        _.each(params, function(val, key) {
          if (Array.isArray(val)) {
            return _.each(val, function(item) {
              return form.append(angular.element("<input></input>").attr('type', 'hidden').attr('name', `${key}[]`).attr('value', item));
            });
          } else {
            return form.append(angular.element("<input></input>").attr('type', 'hidden').attr('name', key).attr('value', val));
          }
        });
      }
      return form.appendTo('body').submit().remove();
    }
  };
});
